import { RootState } from '@/store'
import { GetterTree, Module } from 'vuex'
// @ts-ignore
import countries from '../../assets/alpha-2-countries.json'

type Country = {
  name: string;
  code: string;
}

export type CountryState = {
  countries: Country[];
}

function formatCountry(country: any): Country {
  return {
    name: country.Country_Name,
    code: country.ISO3166_Alpha2_Code
  }
}

class CountryStore implements Module<CountryState, RootState> {
  namespaced = true
  state = () => ({
    countries: countries.map((country: any) => formatCountry(country))
  })

  getters?: GetterTree<CountryState, RootState> | undefined = {
    countrySelect (state) {
      return state.countries
    }
  }
}

export default new CountryStore()
